import Anchor from '@oneflare/flarekit/lib/components/Anchor';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const NavigationItemStyled = styled(Anchor)`
  padding: 8px 0;
  margin-right: 40px;
  position: relative;
  font-size: 16px;
  font-weight: ${({ isActive }) => (isActive ? 'bold' : 'normal')};
  color: ${({ theme }) => theme.color.gunMetal};

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: ${({ isActive }) => (isActive ? '100%' : 0)};
    height: 2px;
    ${({ theme, isActive }) => (isActive && `background-color: ${theme.color.primaryDark}`)};
  }

  ${media.smUp`
    margin-right: 56px;
    color: ${({ theme }) => theme.color.charcoal};

    &:hover {
      text-decoration: none;
      color: ${({ theme }) => theme.color.charcoal};
    }

    &:hover:before {
      width: 100%;
      background-color: ${({ theme }) => (theme.color.primaryDark)};
    }
  `}
`;
